"use strict";
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (_) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.pruneRequestCaches = void 0;
var _constants_1 = require("../_constants");
var pruneRequestCaches = function (_a) {
    var force = _a.force;
    return __awaiter(void 0, void 0, void 0, function () {
        var t1, currentTimestamp_1, prunedCaches_1, projectCachesList, t2, error_1;
        return __generator(this, function (_b) {
            switch (_b.label) {
                case 0:
                    _b.trys.push([0, 3, , 4]);
                    t1 = performance.now();
                    currentTimestamp_1 = new Date().getTime();
                    prunedCaches_1 = [];
                    return [4 /*yield*/, caches.keys()];
                case 1:
                    projectCachesList = _b.sent();
                    // eslint-disable-next-line no-console
                    console.log('%cPruneRequestCaches run', _constants_1.LOGS_STYLES.main);
                    return [4 /*yield*/, Promise.allSettled(projectCachesList.map(function (projectCacheKey) { return __awaiter(void 0, void 0, void 0, function () {
                            var projectCache, projectCachedRequests, updtedProjectCachedRequests;
                            return __generator(this, function (_a) {
                                switch (_a.label) {
                                    case 0: return [4 /*yield*/, caches.open(projectCacheKey)];
                                    case 1:
                                        projectCache = _a.sent();
                                        return [4 /*yield*/, projectCache.keys()];
                                    case 2:
                                        projectCachedRequests = _a.sent();
                                        return [4 /*yield*/, Promise.allSettled(projectCachedRequests.map(function (projectCachedRequest) { return __awaiter(void 0, void 0, void 0, function () {
                                                var response, expires, cachedValue, size, formattedExpires;
                                                return __generator(this, function (_a) {
                                                    switch (_a.label) {
                                                        case 0: return [4 /*yield*/, projectCache.match(projectCachedRequest.url)];
                                                        case 1:
                                                            response = _a.sent();
                                                            if (!response) {
                                                                return [2 /*return*/];
                                                            }
                                                            expires = response.headers.get('api-expires');
                                                            // if not exist special header in cache item
                                                            if (!expires) {
                                                                return [2 /*return*/];
                                                            }
                                                            return [4 /*yield*/, response.json()];
                                                        case 2:
                                                            cachedValue = _a.sent();
                                                            size = encodeURI(JSON.stringify(cachedValue)).length - 1;
                                                            formattedExpires = Number(expires) || 0;
                                                            if (currentTimestamp_1 > formattedExpires || force) {
                                                                projectCache.delete(projectCachedRequest.url);
                                                                prunedCaches_1.push({ key: projectCachedRequest.url, size: size });
                                                                // eslint-disable-next-line no-console
                                                                console.log("%cCache is expired and was deleted: " + projectCachedRequest.url, _constants_1.LOGS_STYLES.warning);
                                                            }
                                                            return [2 /*return*/];
                                                    }
                                                });
                                            }); }))];
                                    case 3:
                                        _a.sent();
                                        return [4 /*yield*/, projectCache.keys()];
                                    case 4:
                                        updtedProjectCachedRequests = _a.sent();
                                        if (!!updtedProjectCachedRequests.length) return [3 /*break*/, 6];
                                        return [4 /*yield*/, caches.delete(projectCacheKey)];
                                    case 5:
                                        _a.sent();
                                        _a.label = 6;
                                    case 6: return [2 /*return*/];
                                }
                            });
                        }); }))];
                case 2:
                    _b.sent();
                    t2 = performance.now();
                    // eslint-disable-next-line no-console
                    console.log('%cPruneRequestCaches result', _constants_1.LOGS_STYLES.main, {
                        duration: t2 - t1,
                        prunedCaches: prunedCaches_1,
                        prunedCachesCount: prunedCaches_1.length,
                    });
                    return [2 /*return*/, {
                            duration: t2 - t1,
                            prunedCaches: prunedCaches_1,
                            prunedCachesCount: prunedCaches_1.length,
                        }];
                case 3:
                    error_1 = _b.sent();
                    console.error('Error in pruneRequestCaches', error_1);
                    return [3 /*break*/, 4];
                case 4: return [2 /*return*/];
            }
        });
    });
};
exports.pruneRequestCaches = pruneRequestCaches;
